/**
 * 公用下拉组件
 * @author VenDream
 * @since 18/04/17
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './dropdown.less';

class DropDown extends Component {
  static propTypes = {
    classname: PropTypes.string,
    selected: PropTypes.number,
    items: PropTypes.array,
    onSelected: PropTypes.func,
  };

  static defaultProps = {
    selected: 0,
    classname: '',
    onSelected: () => {},
  };

  constructor() {
    super();

    this.state = {
      folding: true,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.checkClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkClickOutside);
  }

  // 渲染隐藏的用于提交表单的input
  getSubmitInput() {
    const { items, selected } = this.props;
    const { value, text } = items[selected];

    return (
      <input className="submit-input" type="submit" value={value || text} />
    );
  }

  // 渲染当前的选中项
  getSelectedItem() {
    const { items, selected } = this.props;
    const { text } = items[selected];

    return (
      <div className="selected-item" title={text} onClick={this.handleFold}>
        {text}
      </div>
    );
  }

  // 渲染所有可选项
  getItemList() {
    const { items, selected } = this.props;
    const lis = [];

    for (const [i, item] of Object.entries(items)) {
      const { value, text } = item;
      const cls = classnames('item', ~~i === selected ? 'selected' : '');

      lis.push(
        <li
          className={cls}
          key={i}
          title={text}
          onClick={this.handleSelected.bind(this, ~~i, value || text, text)}>
          {text}
        </li>
      );
    }

    return (
      <ul className="item-list" ref={node => (this.list = node)}>
        {lis}
      </ul>
    );
  }

  // 显示/隐藏下拉列表
  handleFold = () => {
    const { folding } = this.state;
    this.setState({ folding: !folding });
  };

  // 选中下拉项
  handleSelected = (idx, value, text) => {
    this.setState({ folding: true });

    this.props.onSelected(idx, value, text);
  };

  // 检查是否点击了下拉组件的外面
  checkClickOutside = e => {
    if (this.root) {
      const isClickOutside = !this.root.contains(e.target);
      isClickOutside && this.setState({ folding: true });
    }
  };

  render() {
    const { folding } = this.state;
    const { classname } = this.props;

    const cls = classnames({
      cmp: 1,
      's-dropdown': 1,
      [classname]: classname,
      folding,
      transitionable: 1,
    });

    return (
      <div className={cls} ref={node => (this.root = node)}>
        {this.getSubmitInput()}
        {this.getSelectedItem()}
        {this.getItemList()}
      </div>
    );
  }
}

export default DropDown;
